import { create } from 'zustand';
import type { Deal } from '@/hooks/useInfiniteDealsQuery';

interface DealsStore {
  selectedDeal: Deal | null;

  // Add filtered deals data
  isDealsLoading: boolean;
  dealsError: Error | null;

  // Actions
  actions: {
    setSelectedDeal: (deal: Deal | null) => void;

    // Add filtered deals actions
    setDealsLoading: (loading: boolean) => void;
    setDealsError: (error: Error | null) => void;
  };
}

const useDealsStore = create<DealsStore>()((set) => ({
  // Initial state
  selectedDeal: null,

  isDealsLoading: false,
  dealsError: null,

  actions: {
    setSelectedDeal: (deal) => set({ selectedDeal: deal }),
    setDealsLoading: (isDealsLoading) => set({ isDealsLoading }),
    setDealsError: (dealsError) => set({ dealsError }),
  },
}));

// Actions
export const useDealsStoreActions = () => useDealsStore((state) => state.actions);

// Selectors
export const useDealsSelectedDeal = () => useDealsStore((state) => state.selectedDeal);

// Add new selectors for filtered deals
export const useDealsIsLoading = () => useDealsStore((state) => state.isDealsLoading);
export const useDealsError = () => useDealsStore((state) => state.dealsError);
